import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Fruit, FruitType } from "../utils/types";
import { fruits, FRUITS_DROP_TIMEOUT, GAME_TIME, MAX_FALSE_CHOICES } from "../utils/constants";
import successSound from "../sounds/success.mp3";
import wrongSound from "../sounds/wrong.mp3";
import useTimer from "../hooks/useTimer";
import { useNavigate } from "react-router-dom";

function Game() {
  const navigate = useNavigate()
  const [score, setScore] = useState<number>(0);
  const [falseChoicesCount, setFalseChoicesCount] = useState<number>(0);
  const [fruitsList, setFruitsList] = useState<Fruit[]>([]);

  useEffect(() => {
    const interval = setInterval(() => {
      const getRandomFruitIndex =Math.floor(Math.random() * (fruits.length ));
      setFruitsList([
        ...fruitsList,
        {
          ...fruits[getRandomFruitIndex],
          left: Math.floor(Math.random() * (90 - 5 + 1)) + 5,
        },
      ]);
    }, FRUITS_DROP_TIMEOUT);

    return () => {
      interval && clearInterval(interval);
    };
  }, [fruitsList]);

  const clickAction = useCallback(
    (fruit: Fruit, index: number) => {
      if (fruit.clicked) return
      if (fruit.type === FruitType.Healthy) {
        setScore(score => score + 10)
        new Audio(successSound).play();
      } else {
        setScore(score => score - 5)
        setFalseChoicesCount(n => {
          const newVal = n + 1;
          if (newVal >= MAX_FALSE_CHOICES) onTimeFinish(true)
          return newVal
        })
        new Audio(wrongSound).play();
      }
      const fruitsClone = [...fruitsList];
      fruitsClone.splice(index, 1, { ...fruit, clicked: true });
      setFruitsList(fruitsClone);
    },
    [fruitsList, score, falseChoicesCount]
  );

  const onTimeFinish = useCallback(
    (forceLose:boolean = false) => {
      if (score > 0 && !forceLose) {
        navigate('/result/win')
      } else {
        navigate('/result/lose')
      }
    },
    [score, falseChoicesCount]
  );
  const time = useTimer(GAME_TIME, onTimeFinish)
  return (
    <section className="game-container">
      <article className="score-container">
        <div>
          <img src='/assets/score-icon.png' draggable="false" />
        </div>
        <span>{score}  </span>

      </article>
      <article className="timer-container">
        <span> {time} </span>
      </article>
      <div className="human-container">
        {/*  <img src="/assets/human.png" draggable="false" />*/}
      </div>
      <article className="fruits-container">
        {fruitsList.map((fruit, index) => (
          <div
            onClick={() => {
              clickAction(fruit, index);
            }}
            key={index}
            className={`fall ${fruit.clicked ? "hide" : ""}`}
            style={{ left: `${fruit.left}%` }}
          >
            <img src={`/assets/${fruit.name}`} draggable="false" />
            <img src={`/assets/${fruit.type === FruitType.Healthy ? 'Healthy.png' : 'Unhealthy.png'}`} draggable="false" className="score-notation" />
          </div>
        ))}
      </article>
    </section>
  );
}

export default Game;
